import { render, staticRenderFns } from "./index.vue?vue&type=template&id=128a1f51&"
import script from "./script.ts?vue&type=script&lang=ts&"
export * from "./script.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports